import {GeoUtil} from "@/utils";
import * as geolib from 'geolib';

const TYPHOON_CLASS_MAPPING = {
  0: "熱帯低気圧", 1: "台風(TS)", 2: "台風(STS)", 3: "台風(TY)", 9: "温帯低気圧"
}

const TYPHOON_AREA_CLASS_MAPPING = {
  1: "大型", 2: "超大型"
}

const TYPHOON_INTENSITY_CLASS_MAPPING = {
  1: "強い", 2: "非常に強い", 3: "猛烈な"
}

const CENTER_PART_DIRECTION_MAPPING = {
  1: "北北東", 2: "北東", 3: "東北東", 4: "東", 5: "東南東", 6: "南東", 7: "南南東", 8: "南",
  9: "南南西", 10: "南西", 11: "西", 12: "西南西", 13: "西北西", 14: "北西", 15: "北北西", 16: "北",
}

const STORM_AREA_DIRECTION_MAPPING = {
  1: "北", 2: "北東", 3: "東", 4: "南東", 5: "南", 6: "南西", 7: "西", 8: "北西"
}


export default {
  data() {
    return {
      TYPHOON_CLASS_MAPPING: TYPHOON_CLASS_MAPPING,
      TYPHOON_AREA_CLASS_MAPPING: TYPHOON_AREA_CLASS_MAPPING,
      TYPHOON_INTENSITY_CLASS_MAPPING: TYPHOON_INTENSITY_CLASS_MAPPING,
      CENTER_PART_DIRECTION_MAPPING: CENTER_PART_DIRECTION_MAPPING,
      STORM_AREA_DIRECTION_MAPPING: STORM_AREA_DIRECTION_MAPPING,
    };
  },
  methods: {
    getTyphoonName(number, typhoonClass) {
      if (number !== null) {
        let _number = String(number).substr(2, 4);
        return `台風${Number(_number)}号`
      }
      return TYPHOON_CLASS_MAPPING[typhoonClass]
    },
    getCoordinateVal(centerCoordinate) {
      let centerCoordinateDegree = this.getCoordinateWithDegree(centerCoordinate)
      let lat = geolib.decimalToSexagesimal(centerCoordinateDegree[0])
      let lng = geolib.decimalToSexagesimal(centerCoordinateDegree[1])
      let lnglat = `N${lng}, E${lat}`
      return lnglat
    },
    getCoordinateWithDegree(centerCoordinate) {
      let coordinateSplit = centerCoordinate.split(",")
      let centerCoordinateDegree = GeoUtil.d_msToDegree([coordinateSplit[0], coordinateSplit[1]])
      return centerCoordinateDegree
    },
    getLocationVal(centerLocation) {
      if (centerLocation === null) return "-"
      return centerLocation
    },
    getPressureVal(pressure) {
      if (pressure === null) return "-"
      return `${pressure}hPa`
    },
    getTyphoonClassVal(typhoonClass) {
      if (typhoonClass === null) return "-"
      return TYPHOON_CLASS_MAPPING[typhoonClass]
    },
    getAreaClassVal(areaClass) {
      if (areaClass === null) return "-"
      return TYPHOON_AREA_CLASS_MAPPING[areaClass]
    },
    getIntensityClassVal(intensityClass) {
      if (intensityClass === null) return "-"
      return TYPHOON_INTENSITY_CLASS_MAPPING[intensityClass]
    },
    getCenterPartDirectionVal(centerPartDirection) {
      if (centerPartDirection === null) return "-"
      return CENTER_PART_DIRECTION_MAPPING[centerPartDirection]
    },
    getSpeedVal(speed) {
      if (speed === null) return "-"
      return `${speed}km/h`
    },
    getWindSpeedVal(windSpeed) {
      if (windSpeed === null) return "-"
      return `${windSpeed}m/s`
    },
    getMaxWindSpeedVal(maxWindSpeed) {
      if (maxWindSpeed === null) return "-"
      return `${maxWindSpeed}m/s`
    },
    getStormAreaVal(stormArea) {
      if (!stormArea) return "-"
      if (stormArea.length === 1) {
        if (stormArea[0].radius === null) return "-"
        if (stormArea[0].direction === null) {
          return `中心から${stormArea[0].radius}km`
        }
        return `${STORM_AREA_DIRECTION_MAPPING[stormArea[0].direction]}${stormArea[0].radius}km`
      }
      let vallist = []
      stormArea.forEach(v => {
        if (v.direction) {
          vallist.push(`${STORM_AREA_DIRECTION_MAPPING[v.direction]}${v.radius}km`)
        }
      })
      return vallist.join(',')
    },
    getStrongWindAreaVal(strongWindArea) {
      if (!strongWindArea) return "-"
      let vallist = []
      if (strongWindArea.length === 1) {
        if (strongWindArea[0].radius === null) return "-"
        if (strongWindArea[0].direction === null) {
          return `中心から${strongWindArea[0].radius}km`
        }
        return `${STORM_AREA_DIRECTION_MAPPING[strongWindArea[0].direction]}${strongWindArea[0].radius}km`
      }
      strongWindArea.forEach(v => {
        if (v.direction) {
          vallist.push(`${STORM_AREA_DIRECTION_MAPPING[v.direction]}${v.radius}km`)
        }
      })
      return vallist.join(',')
    },
    calcCircleTranslate(strongWindAreaFrom, strongWindAreaTo) {
      // let radius = ((strongWindAreaFrom.radius - strongWindAreaTo.radius) / 2) + strongWindAreaTo.radius
      //1: "北", 2: "北東", 3: "東", 4: "南東", 5: "南", 6: "南西", 7: "西", 8: "北西"
      if (strongWindAreaTo.direction === 1) {
        return [0, 20]
      } else if (strongWindAreaTo.direction === 2) {
        return [-20, 20]
      } else if (strongWindAreaTo.direction === 3) {
        return [-20, 0]
      } else if (strongWindAreaTo.direction === 4) {
        return [-20, -20]
      } else if (strongWindAreaTo.direction === 5) {
        return [0, -20]
      } else if (strongWindAreaTo.direction === 6) {
        return [20, -20]
      } else if (strongWindAreaTo.direction === 7) {
        return [20, 0]
      } else if (strongWindAreaTo.direction === 8) {
        return [20, 20]
      }
    }
  }
}
